export enum CheckoutStates {
  GUEST = 'guest',
  OTO = 'oto',
  SAVED = 'saved',
}
